document.addEventListener('click', function (e) {
  var btn = e.target.closest('.tefat-produkt--merch .tefat-produkt__antal-btn');
  if (!btn) return;
  var wrapper = btn.closest('.tefat-produkt__antal-wrapper');
  if (!wrapper) return;
  var input = wrapper.querySelector('.tefat-produkt__antal-input');
  if (!input) return;
  e.preventDefault();
  var action = btn.dataset.action;
  var currentValue = parseInt(input.value, 10) || 1;
  var min = parseInt(input.min, 10) || 1;
  var max = input.max ? parseInt(input.max, 10) : Number.POSITIVE_INFINITY;
  if (action === 'increase' && currentValue < max) input.value = String(currentValue + 1);
  if (action === 'decrease' && currentValue > min) input.value = String(currentValue - 1);
  syncAntalInputs(wrapper, input.value);
});

function syncAntalInputs(originWrapper, value) {
  var section = originWrapper.closest('.tefat-produkt--merch[data-section-id]');
  if (!section) return;
  var alla = section.querySelectorAll('.tefat-produkt__antal-input');
  alla.forEach(function (el) {
    if (el.value !== value) el.value = value;
  });
}

document.addEventListener('input', function (e) {
  var input = e.target.closest('.tefat-produkt--merch .tefat-produkt__antal-input');
  if (!input) return;
  var wrapper = input.closest('.tefat-produkt__antal-wrapper');
  if (!wrapper) return;
  syncAntalInputs(wrapper, input.value);
});

function initMerchProductSection(section) {
  var sid = section.dataset.sectionId;
  if (!sid) return;

  var productDataEl = document.getElementById('product-data-' + sid);
  var variantSelect = document.getElementById('variant-select-' + sid);
  var quantityInputMobile = document.getElementById('quantity-' + sid);
  var quantityInputDesktop = document.getElementById('quantity-desktop-' + sid);
  var form = document.getElementById('product-form-' + sid);
  var variantUi = section.querySelector('[data-variant-ui="' + sid + '"]');
  var variantTrigger = variantUi ? variantUi.querySelector('.tefat-produkt__variant-trigger') : null;
  var variantDropdown = variantUi ? variantUi.querySelector('[data-variant-dropdown]') : null;
  var variantLabel = variantUi ? variantUi.querySelector('.tefat-produkt__variant-label') : null;
  var variantOptions = variantUi ? variantUi.querySelectorAll('.tefat-produkt__variant-option[data-variant-id]') : [];
  var huvudbild = section.querySelector('.tefat-produkt__bild');
  var priceEl = section.querySelector('.tefat-produkt__vaerde--pris');
  var zoomBtn = section.querySelector('.tefat-produkt__zoom');

  var galleri = section.querySelector('.tefat-produkt__galleri');
  var thumbnails = galleri ? galleri.querySelectorAll('.tefat-produkt__thumbnail') : [];
  var mediaDataEl = document.getElementById('media-data-' + sid);
  var produktBilder = [];
  try {
    produktBilder = mediaDataEl ? JSON.parse(mediaDataEl.textContent) : [];
  } catch (err) {
    produktBilder = [];
  }
  var aktivBildIndex = 0;
  if (huvudbild && produktBilder.length) {
    var initSrc = huvudbild.getAttribute('src') || '';
    for (var ii = 0; ii < produktBilder.length; ii++) {
      if (produktBilder[ii].src && initSrc.indexOf(produktBilder[ii].src.split('?')[0].split('/').pop()) !== -1) {
        aktivBildIndex = ii;
        break;
      }
    }
  }
  thumbnails.forEach(function (t) {
    t.classList.toggle('tefat-produkt__thumbnail--aktiv', parseInt(t.dataset.index, 10) === aktivBildIndex);
  });
  var bildWrapper = galleri ? galleri.querySelector('.tefat-produkt__bild-wrapper') : null;

  var visaBild = function (index) {
    if (!produktBilder.length || !huvudbild) return;
    index = ((index % produktBilder.length) + produktBilder.length) % produktBilder.length; // wrap around
    if (Number.isNaN(index) || index === aktivBildIndex || !produktBilder[index]) return;
    thumbnails.forEach(function (t) { t.classList.remove('tefat-produkt__thumbnail--aktiv'); });
    if (thumbnails[index]) thumbnails[index].classList.add('tefat-produkt__thumbnail--aktiv');
    huvudbild.style.opacity = '0';
    setTimeout(function () {
      huvudbild.src = produktBilder[index].src;
      huvudbild.srcset = produktBilder[index].srcset;
      huvudbild.alt = produktBilder[index].alt;
      requestAnimationFrame(function () { huvudbild.style.opacity = '1'; });
    }, 150);
    aktivBildIndex = index;
  };

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      visaBild(parseInt(thumb.dataset.index, 10));
    });
  });

  // Mobile gallery is a native horizontal scroll-snap strip (no JS swipe).
  // For zoom, resolve the image currently snapped into view.
  var mobilGalleri = galleri ? galleri.querySelector('.tefat-produkt__mobil-galleri') : null;
  var aktuellBild = function () {
    if (mobilGalleri && mobilGalleri.offsetParent !== null && mobilGalleri.clientWidth) {
      var idx = Math.round(mobilGalleri.scrollLeft / mobilGalleri.clientWidth);
      var bilder = mobilGalleri.querySelectorAll('.tefat-produkt__mobil-bild');
      if (bilder[idx]) return { src: bilder[idx].currentSrc || bilder[idx].src, alt: bilder[idx].alt };
    }
    return { src: huvudbild ? huvudbild.src : '', alt: huvudbild ? huvudbild.alt : '' };
  };

  if (zoomBtn && huvudbild) {
    var zoomOverlay = document.querySelector('.tefat-zoom-overlay');
    if (!zoomOverlay) {
      zoomOverlay = document.createElement('div');
      zoomOverlay.className = 'tefat-zoom-overlay';
      zoomOverlay.innerHTML = '<div class="tefat-zoom-overlay__content"><img src="" alt="" class="tefat-zoom-overlay__bild"></div>';
      document.body.appendChild(zoomOverlay);
    }
    var zoomBild = zoomOverlay.querySelector('.tefat-zoom-overlay__bild');
    var openZoom = function () {
      var bild = aktuellBild();
      zoomBild.src = bild.src;
      zoomBild.alt = bild.alt;
      zoomOverlay.classList.add('tefat-zoom-overlay--aktiv');
      document.body.style.overflow = 'hidden';
      if (window.lenis) window.lenis.stop();
    };
    var closeZoom = function () {
      zoomOverlay.classList.remove('tefat-zoom-overlay--aktiv');
      document.body.style.overflow = '';
      if (window.lenis) window.lenis.start();
    };
    zoomBtn.addEventListener('click', openZoom);
    zoomOverlay.addEventListener('click', closeZoom);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && zoomOverlay.classList.contains('tefat-zoom-overlay--aktiv')) closeZoom();
    });
  }

  var addBtn = document.getElementById('add-to-cart-' + sid);
  var addBtnMobile = form ? form.querySelector('[data-add-to-cart-mobile]') : null;
  var allAddBtns = [addBtn, addBtnMobile].filter(Boolean);

  var productData = null;
  try {
    productData = productDataEl ? JSON.parse(productDataEl.textContent) : null;
  } catch (err) {
    productData = null;
  }

  var getVariantById = function (id) {
    if (!productData) return null;
    return productData.variants.find(function (v) { return v.id === parseInt(id, 10); });
  };

  var formatMoney = function (variant) {
    var valutaKod = (productData && productData.currency) || 'SEK';
    var belopp = variant.price_formatted != null ? variant.price_formatted : String(Math.round(variant.price / 100));
    return valutaKod + ' ' + belopp;
  };

  var formatSpecValue = function (value) {
    if (!value) return '';
    return String(value).replace(/(\d+(?:[.,]\d+)?)|([—–-])|(\s+)/g, function (match, num, dash, space) {
      if (num) return '<span class="spec-number">' + num + '</span>';
      if (dash) return '<span class="spec-dash">' + dash + '</span>';
      if (space) return '<span class="spec-space"> </span>';
      return match;
    });
  };

  var updateMetafieldUI = function (variant) {
    if (!variant || !variant.metafields) return;
    var meta = variant.metafields;
    var specFields = ['weight', 'fit', 'made_in', 'printed', 'fabric', 'wash_instructions'];
    specFields.forEach(function (field) {
      var el = section.querySelector('[data-metafield="' + field + '"]');
      if (el && meta[field]) el.innerHTML = formatSpecValue(meta[field]);
    });
    var specContainer = section.querySelector('[data-spec-container]');
    if (specContainer && meta.spec_order) {
      var orderList = meta.spec_order.split(',').map(function (s) { return s.trim(); });
      var specRows = Array.from(specContainer.querySelectorAll('[data-spec-row]'));
      specRows.sort(function (a, b) {
        var aKey = a.dataset.specRow;
        var bKey = b.dataset.specRow;
        var aIndex = orderList.indexOf(aKey);
        var bIndex = orderList.indexOf(bKey);
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        var aDefault = parseInt(a.dataset.specDefaultOrder, 10) || 999;
        var bDefault = parseInt(b.dataset.specDefaultOrder, 10) || 999;
        return aDefault - bDefault;
      });
      specRows.forEach(function (row) { specContainer.appendChild(row); });
    }
  };

  var updateVariantUI = function (variant) {
    if (!variant) return;
    if (priceEl) priceEl.textContent = formatMoney(variant);
    allAddBtns.forEach(function (btn) {
      if (variant.available) { btn.disabled = false; btn.textContent = 'ADD TO CART'; }
      else { btn.disabled = true; btn.textContent = 'SOLD OUT'; }
    });
    var alla = [quantityInputMobile, quantityInputDesktop].filter(Boolean);
    alla.forEach(function (input) {
      if (variant.inventory_quantity > 0) {
        input.max = variant.inventory_quantity;
        if (parseInt(input.value, 10) > variant.inventory_quantity) {
          input.value = variant.inventory_quantity;
        }
      }
    });
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
    if (variant.featured_media_id && produktBilder.length && huvudbild) {
      var mediaIndex = produktBilder.findIndex(function (media) { return String(media.id) === String(variant.featured_media_id); });
      if (mediaIndex !== -1) {
        var media = produktBilder[mediaIndex];
        huvudbild.style.opacity = '0';
        setTimeout(function () {
          huvudbild.src = media.src;
          huvudbild.srcset = media.srcset;
          huvudbild.alt = media.alt;
          aktivBildIndex = mediaIndex;
          thumbnails.forEach(function (thumb) {
            var isActive = parseInt(thumb.dataset.index, 10) === mediaIndex;
            thumb.classList.toggle('tefat-produkt__thumbnail--aktiv', isActive);
          });
          requestAnimationFrame(function () { huvudbild.style.opacity = '1'; });
        }, 150);
      }
    } else if (variant.featured_image && huvudbild) {
      huvudbild.style.opacity = '0';
      setTimeout(function () {
        huvudbild.src = variant.featured_image;
        requestAnimationFrame(function () { huvudbild.style.opacity = '1'; });
      }, 150);
    }
    updateMetafieldUI(variant);
  };

  var syncVariantUiFromSelect = function () {
    if (!variantSelect || !variantLabel || !variantOptions.length) return;
    var currentId = variantSelect.value;
    var active = Array.from(variantOptions).find(function (b) { return b.dataset.variantId === currentId; });
    variantOptions.forEach(function (b) {
      var isActive = b === active;
      b.classList.toggle('tefat-produkt__variant-option--aktiv', isActive);
      b.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    if (active) variantLabel.innerHTML = active.innerHTML.replace(/\s*–\s*SOLD OUT\s*$/i, '').trim();
  };

  if (variantUi && variantTrigger && variantLabel && variantSelect && variantDropdown && variantOptions.length) {
    var closeDropdown = function () {
      variantUi.dataset.open = 'false';
      variantTrigger.setAttribute('aria-expanded', 'false');
      variantDropdown.setAttribute('aria-hidden', 'true');
    };
    var openDropdown = function () {
      variantUi.dataset.open = 'true';
      variantTrigger.setAttribute('aria-expanded', 'true');
      variantDropdown.setAttribute('aria-hidden', 'false');
    };
    syncVariantUiFromSelect();
    variantUi.dataset.open = 'false';
    variantDropdown.setAttribute('aria-hidden', 'true');
    variantTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (variantUi.dataset.open === 'true') closeDropdown();
      else openDropdown();
    });
    variantOptions.forEach(function (optBtn) {
      optBtn.addEventListener('click', function () {
        var targetId = optBtn.dataset.variantId;
        if (!targetId) return;
        variantSelect.value = targetId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        syncVariantUiFromSelect();
        closeDropdown();
      });
    });
    document.addEventListener('pointerdown', function (e) {
      if (!variantUi.contains(e.target)) closeDropdown();
    });
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function (e) {
      var variant = getVariantById(e.target.value);
      updateVariantUI(variant);
      syncVariantUiFromSelect();
    });
  }

  var urlParams = new URLSearchParams(window.location.search);
  var variantParam = urlParams.get('variant');
  if (variantParam && variantSelect) {
    variantSelect.value = variantParam;
    var variant = getVariantById(variantParam);
    if (variant) updateVariantUI(variant);
    syncVariantUiFromSelect();
  }

  var lasAktivtAntal = function () {
    var alla = [quantityInputMobile, quantityInputDesktop].filter(Boolean);
    for (var i = 0; i < alla.length; i++) {
      var el = alla[i];
      if (el.offsetParent !== null) return parseInt(el.value, 10) || 1;
    }
    if (alla[0]) return parseInt(alla[0].value, 10) || 1;
    return 1;
  };

  if (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var vs = document.getElementById('variant-select-' + sid);
      var variantId = vs ? vs.value : (form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null);
      var quantity = lasAktivtAntal();
      if (!variantId) return;
      allAddBtns.forEach(function (b) { b.disabled = true; b.textContent = 'ADDING...'; });
      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
        });
        var data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Could not add to cart');
        allAddBtns.forEach(function (b) { b.textContent = 'ADDED!'; });
        var cartRes = await fetch('/cart.js');
        var cartData = await cartRes.json();
        var cartCountEl = document.getElementById('tefat-cart-count');
        if (cartCountEl) {
          cartCountEl.textContent = String(cartData.item_count);
          cartCountEl.dataset.cartCount = String(cartData.item_count);
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item_count: cartData.item_count } }));
        var cartDrawer = document.getElementById('tefat-cart-drawer');
        if (cartDrawer) {
          try {
            var secRes = await fetch('/?sections=tefat-cart');
            var secData = await secRes.json();
            if (secData['tefat-cart']) {
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = secData['tefat-cart'];
              var newDrawer = tempDiv.querySelector('#tefat-cart-drawer');
              if (newDrawer) {
                cartDrawer.innerHTML = newDrawer.innerHTML;
                if (typeof window.ScrollTrigger !== 'undefined') window.ScrollTrigger.refresh();
              }
            }
          } catch (err) {
            console.warn('Could not refresh cart drawer:', err);
          }
          if (window.tefatCart && typeof window.tefatCart.open === 'function') window.tefatCart.open();
        }
        setTimeout(function () {
          var v = getVariantById(variantId);
          if (v && v.available) {
            allAddBtns.forEach(function (b) { b.disabled = false; b.textContent = 'ADD TO CART'; });
          }
        }, 1500);
      } catch (err) {
        console.error(err);
        allAddBtns.forEach(function (b) { b.disabled = false; b.textContent = 'ADD TO CART'; });
      }
    });
  }
}

function bootMerchProductSections() {
  var sektioner = document.querySelectorAll('.tefat-produkt--merch[data-section-id]');
  sektioner.forEach(function (sec) {
    if (sec.dataset.merchInited === 'true') return;
    sec.dataset.merchInited = 'true';
    initMerchProductSection(sec);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootMerchProductSections);
} else {
  bootMerchProductSections();
}